import React, { useEffect, useState } from 'react';
import Logo from './Logo';

const GmailOAuthReturnPage: React.FC = () => {
  const [redirectUrl, setRedirectUrl] = useState<string>('');
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobile = /android|iphone|ipad|ipod/i.test(userAgent.toLowerCase());
    setIsMobile(mobile);

    const params = new URLSearchParams(window.location.search);
    const search = params.toString() ? `?${params.toString()}` : '';
    const deepLink = `clero://gmail-oauth${search}`;
    setRedirectUrl(deepLink);

    if (mobile) {
      window.location.href = deepLink;
    }
  }, []);

  const handleOpenApp = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 space-y-8 animate-in fade-in duration-500">
      <div className="text-center space-y-6 max-w-md">
        <div className="flex justify-center">
          <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-[#1D8477]"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <i className="fas fa-envelope text-[#1D8477]"></i>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <h1 className="text-2xl font-bold text-gray-900">Returning to Clero</h1>
          <p className="text-gray-500">
            {isMobile
              ? "We're taking you back to the app to finish connecting Gmail."
              : 'Please open the Clero app on your phone to continue.'}
          </p>
        </div>

        {isMobile ? (
          <button
            onClick={handleOpenApp}
            className="w-full bg-[#1D8477] text-white font-bold py-4 px-8 rounded-2xl shadow-lg shadow-green-900/10 active:scale-[0.98] transition-all"
          >
            Return to App
          </button>
        ) : (
          <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100 italic text-sm text-gray-500">
            OAuth flows must be completed on the same device where you started the connection.
          </div>
        )}

        <button
          onClick={() => {
            window.location.href = '/';
          }}
          className="text-gray-400 text-sm hover:underline"
        >
          Back to Home
        </button>
      </div>

      <div className="absolute bottom-10">
        <Logo size="sm" className="opacity-20 grayscale" />
      </div>
    </div>
  );
};

export default GmailOAuthReturnPage;
